<template>
  <div class="col-md-6">
    <div class="bg-blue-grey-100 p-30 font-size-14 clearfix" v-if="showSettingSuspendForm">
      <form v-on:submit.prevent="onSubmitSuspendStatus">
        <div class="row">
          <div class="col-md-12">
            <alert v-show="showSuspendAlert"
              alertClass="m-b-25 alert-dismissible"
              v-bind:type="`${ (successSuspendResponse) ? 'success' : 'danger' }`"
              v-bind:iconClass="`${ (successSuspendResponse) ? 'md-check' : 'md-close' }`">
              <span v-if="successSuspendResponse">{{successSuspendResponse}}</span>
              <span v-else-if="errorSuspendResponse">{{errorSuspendResponse}}</span>
            </alert>
            <h4 class="title">Setting Suspend</h4>
            <form-group>
              <label for="name">Mode</label>
              <select class="form-control" v-model="currentSuspendMode">
                <option value="auto">Auto</option>
                <option value="active">Active</option>
                <option value="suspend">Suspend</option>
              </select>
            </form-group>
            <form-group v-if="currentSuspendMode === 'suspend'" v-bind:error="formErrors.first('suspend_reason')">
              <label for="reason">Reason to client<span class="red-500">*</span></label>
              <input type="text" class="form-control input-lg"  v-model="teamSuspend.suspend_reason">
            </form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button type="submit" class="btn btn-success pull-xs-left">
              Update Plan
            </button>
          </div>
          <div class="col-md-6">
            <button type="button" class="btn btn-link pull-xs-right" v-on:click="cancelSettingSuspendForm">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="bg-blue-grey-100 p-30 font-size-14" v-else>
      <div class="counter counter-md text-xs-left">
        <div class="counter-label text-uppercase m-b-5">Setting Suspend</div>
        <span class="counter-number"> {{currentSuspendMode.toUpperCase() }} </span>
        <div class="counter-label text-uppercase m-b-5 m-t-20">
          <button
            type="button"
            class="btn btn-primary btn-outline"
            v-if="!team.has_reseller"
            v-on:click="toggleSettingSuspendForm">Change setting
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';

export default {
  components: {
    Alert,
    FormGroup,
  },
  props: {
    team: {
      type: Object,
    },
  },
  computed: {
    teamSuspend: function () {
      return this.team && this.team.suspend ? this.team.suspend : [];
    },
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);

    this.validator = new Validator();
    //this.validator.attach('suspend_reason', 'required', { prettyName: 'Suspend Reason' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounth: function () {
    this.updateSupsendMode();
  },
  data: function() {
    return {
      showSuspendAlert: false,
      errorSuspendResponse: null,
      successSuspendResponse: null,
      validator: null,
      formErrors: null,
      currentSuspendMode: 'suspend',
      showSettingSuspendForm: false,
    };
  },
  methods: {
    onSubmitSuspendStatus: function () {
      this.showSuspendAlert = false;

      axios.post(`api/admin/setsuspend`, {
        namespace: this.team.namespace,
        mode: this.currentSuspendMode,
        suspend_reason: this.teamSuspend.suspend_reason,
      })
      .then((response) => {
        this.successSuspendResponse = this.$t('team.response.success');
        this.teamSuspend = response.data;
        this.updateSupsendMode();

        this.errorSuspendResponse = null;
        this.showSuspendAlert = true;
      })
      .catch((error) => {
        // TODO: show error message from api
        if (error.response.status === 422) {
          this.errorSuspendResponse = this.$t('team.response.failed');
          this.formErrors.addAll(error.response.data);
        } else {
          this.errorSuspendResponse = this.$t('team.response.defaultFailed');
        }
        this.showSuspendAlert = true;
      });
    },
    updateSupsendMode: function () {
      if (this.teamSuspend) {
        if (this.teamSuspend.is_manual_locked && !this.teamSuspend.is_suspend) {
          this.currentSuspendMode = 'active';
        } else if (this.teamSuspend.is_manual_locked && this.teamSuspend.is_suspend) {
          this.currentSuspendMode = 'suspend';
        } else {
          this.currentSuspendMode = 'auto';
        }
      }
    },
    toggleSettingSuspendForm: function () {
      this.showSettingSuspendForm = true;
    },
    cancelSettingSuspendForm: function () {
      this.updateSupsendMode();
      this.showSettingSuspendForm = false;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SettingSuspend.vue?9d69cec6